/** Peças de formulário compartilhadas (modal, campos) no mesmo visual do viewer. */
import type { KeyboardEvent, ReactNode } from 'react';

export function Modal({ title, subtitle, onClose, children, testId, width, onKeyDown }: { title: string; /** linha menor sob o título ("Apartamento · vence 10/09/2026 · R$ 2.633,33") */ subtitle?: ReactNode; onClose: () => void; children: ReactNode; testId?: string; /** largura máxima em px (padrão 512) */ width?: number; onKeyDown?: (e: KeyboardEvent<HTMLDivElement>) => void }) {
  return (
    <div className="fixed inset-0 z-40 flex items-end justify-center bg-ink/40 p-0 sm:items-center sm:p-4" role="dialog" aria-modal="true" data-testid={testId} onKeyDown={onKeyDown}>
      <div className="max-h-[92vh] w-full max-w-lg overflow-y-auto rounded-t-2xl bg-surface p-6 shadow-lg sm:rounded-2xl" style={width ? { maxWidth: width } : undefined}>
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0"><h2 className="text-[17px] font-semibold text-ink">{title}</h2>{subtitle && <p className="dlg-sub">{subtitle}</p>}</div>
          <button type="button" onClick={onClose} className="rounded-lg px-2 py-1 text-[13px] text-mute hover:text-ink" aria-label="Fechar">✕</button>
        </div>
        {children}
      </div>
    </div>
  );
}

export const field = 'mt-1 w-full rounded-xl border border-rule bg-paper px-3 py-2.5 text-[15px] text-ink outline-none focus:border-teal disabled:opacity-60';
export const label = 'block text-[12px] font-semibold uppercase tracking-[0.08em] text-mute';

export function Field({ children, text }: { children: ReactNode; text: string }) {
  return (
    <label className="block">
      <span className={label}>{text}</span>
      {children}
    </label>
  );
}

/** Rótulo + controle que NÃO é um input nativo (o seletor com ícones): um <label> em volta de vários botões encaminharia o clique pro primeiro. */
export function FieldBox({ children, text }: { children: ReactNode; text: string }) {
  return (
    <div>
      <span className={label}>{text}</span>
      {children}
    </div>
  );
}

export function Actions({ busy, onCancel, onDelete, submitLabel = 'Salvar' }: { busy: boolean; onCancel: () => void; onDelete?: () => void; submitLabel?: string }) {
  return (
    <div className="mt-6 flex items-center justify-between gap-2">
      <div>
        {onDelete && (
          <button type="button" onClick={onDelete} disabled={busy} className="rounded-xl px-3 py-2 text-[14px] font-semibold text-neg hover:bg-neg-pale disabled:opacity-60" data-testid="form-delete">Excluir</button>
        )}
      </div>
      <div className="flex gap-2">
        <button type="button" onClick={onCancel} disabled={busy} className="rounded-xl px-4 py-2 text-[14px] text-mute hover:text-ink">Cancelar</button>
        <button type="submit" disabled={busy} className="rounded-xl bg-teal px-4 py-2 text-[14px] font-semibold text-white disabled:opacity-60" data-testid="form-submit">{busy ? 'Salvando…' : submitLabel}</button>
      </div>
    </div>
  );
}

/** "1.234,56" / "1234.56" → número. */
export function parseAmount(raw: string): number {
  const s = raw.trim().replace(/\s|R\$/g, '');
  const normalized = s.includes(',') ? s.replace(/\./g, '').replace(',', '.') : s;
  const n = Number(normalized);
  return Number.isFinite(n) ? n : NaN;
}

export const today = () => new Date().toISOString().slice(0, 10);
